module.exports = __webpack_public_path__ + "img/turbo_off.feaffc06.svg";